import React from 'react';
import './card-icon.style.scss';
import {connect} from 'react-redux';
import { toggleCartHidden } from '../../redux/cart/cart.action';
import {ReactComponent as ShoppingIcon} from '../../assets/bag.svg';
import { selectCartItemsCount } from '../../redux/cart/cart.selectors';
import {createStructuredSelector} from 'reselect';

const CardIcon = ({toggleCartHidden, itemCount}) => ( 
  <div className='cart-icon' onClick={toggleCartHidden}>
    <ShoppingIcon className='shopping-icon'/>
    <span className='item-count'>{itemCount}</span>
  </div>
)

const mapStateToProps = createStructuredSelector({
  itemCount: selectCartItemsCount
})
/*
this is taking the state and make it's selectors that take the slice 
of it to make out counter 
*/
 

const mapDispatchToProps = (dispatch) => ({
  toggleCartHidden: () => dispatch(toggleCartHidden())
})

export default connect(mapStateToProps, mapDispatchToProps)(CardIcon);